/* @flow */
import React from 'react';
import type { Map } from 'immutable';
import { connect } from 'react-redux';
import { Observable, type Subscription } from 'rxjs';
import classnames from 'classnames/bind';

import s from './ConfirmationModal.styl';
const cx = classnames.bind(s);

import { actions, getters } from 'modules/app';
import {Button} from 'trustar-2.0/components/Button';
const keydown$ = Observable.defer(() => Observable.fromEvent(document.body, 'keydown'));
const enterKey$ = keydown$.filter(e => e.key === 'Enter');
const escapeKey$ = keydown$.filter(e => e.key === 'Escape');

export const ConfirmationModal = connect(
  (state) => ({ data: getters.confirmation(state)}),
  { confirm: actions.confirm }
)(class extends React.Component {
  static displayName = 'Confirmation';
  sub: Subscription;
  props: {
    data: Map<any, any>,
    confirm: Function,
  }
  componentDidMount() {
    /* Filter only the key events that occur when this component is visible,
     * and prevent default so event doesn't propagate up */
    this.sub = Observable.merge(
      enterKey$.filter(this.filter).do(e => e.preventDefault()).do(this.confirm),
      escapeKey$.filter(this.filter).do(e => e.preventDefault()).do(this.reject),
    ).subscribe();
  }
  filter = () => {
    return !!this.props.data.get('visible');
  }
  confirm = () => {
    /* Run whatever accept callback is attached to the current confirmation */
    const accept = this.props.data.get('accept');
    this.props.confirm({ visible: false }); // close modal first, in case next accept triggers another confirmation
    accept();
  }
  reject = () => {
    this.props.confirm({ visible: false });
  }
  render() {
    const { data } = this.props;
    const active = data.get('visible');
    return (
      <div className={cx('ConfirmationDialog', { active })}>
        <div className={cx('dialog', { active })}>
          <h5>{data.get('message')}</h5>
          <div className={cx('controls')}>
            <Button fill={'none'} className={cx('cancelButton')} onClick={this.reject}>
              No, cancel
            </Button>
            <Button
              className='confirmButton'
              cyid='confirmButton'
              onClick={this.confirm}
            >
              Yes, I'm sure
            </Button>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./web_modules/trustar/components/ConfirmationModal.js